import classNames from 'classnames';
import { AppRoutes } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';

interface GuestAuthLinksProps {
  className?: string;
  dataGTM: string;
}

export const GuestAuthLinks = ({ className, dataGTM }: GuestAuthLinksProps) => {
  return (
    <div
      className={classNames('nj-tier-auth-footer-button-wrapper', className)}
    >
      <Button
        as="link"
        data-e2e="login-button"
        to={AppRoutes.LOGIN}
        color="secondary-outline"
        fullWidth
      >
        Log in
      </Button>
      <Button
        as="link"
        id={dataGTM}
        data-e2e="signup-button"
        to={AppRoutes.SIGN_UP}
        color="highlight"
        fullWidth
      >
        Sign up for free
      </Button>
    </div>
  );
};
